// extracted by mini-css-extract-plugin
export default {"tabletImg":"GH","desktopImg":"HH","mobileImg":"IH","backgroundImage":"JH","content":"KH","rtbLeft":"LH","rtbRight":"MH","imageContainer":"NH","rtbBox":"OH","line":"PH"};
    if(module.hot) {
      // 1713361651669
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  